import { useState } from "react";
import SectionHeading from "@/pages/home/components/SectionHeading";
import { consults } from "@/mocks/content";

export default function ConsultSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="consult" className="scroll-mt-20 bg-background-50 py-16 md:py-24">
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-10 px-6 md:px-8 lg:grid-cols-[0.85fr_1.15fr] lg:gap-14">
        <div>
          <SectionHeading
            eyebrow="情感咨询"
            title="那些说不出口的困惑，先在这里找答案"
            desc="下面整理了读者最常问的几个问题。答案不是标准结论，而是一种看待问题的角度，希望能帮你把心里那团乱麻理出个头绪。"
          />
          <div className="mt-8 rounded-lg border border-background-200 bg-secondary-50 p-5">
            <div className="flex items-center gap-2 text-secondary-700">
              <i className="ri-chat-heart-line"></i>
              <span className="font-label text-sm font-medium">给正在困惑的你</span>
            </div>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700">
              如果你遇到的问题这里没有写到，也不代表它不重要。先照顾好自己的情绪，再慢慢处理关系；必要时，寻求专业情感咨询也是一种成熟的选择。
            </p>
          </div>
        </div>

        <div className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-100">
          {consults.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div key={item.q}>
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? null : index)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                  aria-expanded={isOpen}
                >
                  <span className="flex items-start gap-3 font-label text-sm font-medium text-foreground-900 md:text-base">
                    <span className="text-primary-500">Q</span>
                    {item.q}
                  </span>
                  <i
                    className={`shrink-0 text-lg text-foreground-400 transition-transform duration-300 ${
                      isOpen ? "ri-subtract-line rotate-180" : "ri-add-line"
                    }`}
                  ></i>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    isOpen ? "max-h-[1400px] opacity-100" : "max-h-0 opacity-0"
                  }`}
                >
                  <div className="px-5 pb-5 pl-11">
                    <p className="text-sm leading-relaxed text-foreground-600">{item.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}